export const DELIVERY_ATTEMPT_SLUGS = {
  INACCESSIBLE_PLACE: 'inaccessible_place',
  DELIVERY_ADDRESS_NOT_FOUND: 'delivery_address_not_found',
  RESPONSIBLE_ABSENT: 'responsible_absent',
  CANCELED_AFTER_INACCESSIBLE_PLACE: 'canceled_after_inaccessible_place',
  CANCELED_AFTER_RESPONSIBLE_ABSENT: 'canceled_after_responsible_absent',
  CANCELED_AFTER_DELIVERY_ADDRESS_NOT_FOUND:
    'canceled_after_delivery_address_not_found',
};

export const MAIN_SLUGS = {
  IN_TRANSIT: 'in_transit',
  READY_FOR_PICKUP: 'ready_for_pickup',
  FINISHED: 'finished',
  CANCELLED: 'canceled',
  ...DELIVERY_ATTEMPT_SLUGS,
} as const;

export const MAIN_STATUSES = {
  PENDING_PAYMENT: 'pending_payment',
  WAITING_PAYMENT: 'waiting_approval',
  WAITING_SEPARATION: 'waiting_separation',
} as const;

export const STEP_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PARTIAL: 'partial',
  CANCELLED: 'canceled',
  IN_PROGRESS: 'in_progress',
} as const;
